import { render } from "./ProductDetailSheet.vue?vue&type=template&id=d6399126&scoped=true"
import script from "./ProductDetailSheet.vue?vue&type=script&lang=js"
export * from "./ProductDetailSheet.vue?vue&type=script&lang=js"

import "./ProductDetailSheet.vue?vue&type=style&index=0&id=d6399126&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6399126"]])

export default __exports__